export default "__VITE_ASSET__Do7nmJ_x__"